import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../styles/theme'

import type { GetVehicleType } from '../../../types/GetVehicle'

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.regular};

    @media print {
        page-break-inside: avoid;
    }
`;

const HeaderRow = styled.tr`
    background-color: Black;
    color: White;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.bold};

    @media print {
        background-color: Black !important;
        color: White !important;
    }
`;

const TableCell = styled.td`
    border: 1px solid black;
    padding: 8px;
    white-space: nowrap;
`;

const Label = styled.div`
    font-size: ${props => props.theme.font.size.small};
    font-weight: ${props => props.theme.font.weight.bold};
`;

interface VehiclesProps {
    vehicles: GetVehicleType[];
}

const Vehicles: React.FC<VehiclesProps> = ({ vehicles }) => {

    return (
        <ThemeProvider theme={theme} >
            {
                vehicles.map((vehicle, index) => (
                    <Table key={index} cellPadding="0" cellSpacing="0">
                        <tbody>
                            <HeaderRow>
                                <td>VEHICLE</td>
                            </HeaderRow>
                            <tr>
                                <td>
                                    <Table key={index} cellPadding="2" cellSpacing="0">
                                        <tbody>
                                            <tr>
                                                <TableCell>
                                                    <Label>Involvement</Label>
                                                    {vehicle && vehicle.involvement ? vehicle.involvement : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Type</Label>
                                                    {vehicle && (vehicle.vehicleDescription || vehicle.vehicleType) ? (vehicle.vehicleDescription || vehicle.vehicleType) : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Year</Label>
                                                    {vehicle && vehicle.year ? vehicle.year : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Make</Label>
                                                    {vehicle && (vehicle.makeCode || vehicle.makeDescription) ? (vehicle.makeCode || vehicle.makeDescription) : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Model</Label>
                                                    {vehicle && (vehicle.modelDescription || vehicle.modelCode) ? (vehicle.modelDescription || vehicle.modelCode) : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Style</Label>
                                                    {vehicle && (vehicle.styleCode || vehicle.styleDescription) ? (vehicle.styleCode || vehicle.styleDescription) : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Color</Label>
                                                    {vehicle && vehicle.color ? vehicle.color : '\u00A0'}
                                                </TableCell>
                                                <TableCell width="100%">
                                                    &nbsp;
                                                </TableCell>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                            </tr>
                        </tbody>
                    </Table>

                ))
            }
        </ThemeProvider>
    );
}

export default Vehicles;